import { Image, Space } from "antd";
import { FaFacebook } from "react-icons/fa6";
import DownloadIcon from "../../../assets/icons/DownloadIcon";
import FacebookIcon from "../../../assets/icons/FacebookIcon";
import InstagramIcon from "../../../assets/icons/InstagramIcon";
import LinkedinIcon from "../../../assets/icons/LinkedinIcon";
import PDF from "../../../assets/images/pdf.svg";
import { formatDate } from "../../../lib/time";
import { GetEmployeeDetailsResponseType } from "../../../types";
import { getExtension } from "../../../utils/string";
import InfoItem from "../../common/InfoItem";

type Props = {
  data?: GetEmployeeDetailsResponseType;
};

export default function PersonalInfo({ data }: Props) {
  const employeeDetails = data?.data?.employee;

  return (
    <ul>
      <InfoItem title="Gender">
        {employeeDetails?.member?.profile?.gender}
      </InfoItem>
      <InfoItem title="Phone">{employeeDetails?.mobile}</InfoItem>
      <InfoItem title="Date of Birth">
        {employeeDetails?.member?.profile?.dob
          ? formatDate(employeeDetails?.member?.profile?.dob)
          : undefined}
      </InfoItem>
      <InfoItem title="Address">
        {employeeDetails?.member?.profile?.address}
      </InfoItem>
      <InfoItem title="Nationality">
        {employeeDetails?.member?.profile?.nationality}
      </InfoItem>
      <InfoItem title="NID">
        <div className="flex items-center justify-between">
          {employeeDetails?.member?.profile?.nid_no || "N/A"}
          {employeeDetails?.member?.profile?.nid_image_front ||
          employeeDetails?.member?.profile?.nid_image_back ? (
            <div className="inline-flex flex-wrap gap-4">
              {employeeDetails?.member?.profile?.nid_image_front ? (
                getExtension(
                  employeeDetails?.member?.profile?.nid_image_front
                ) === "pdf" ? null : (
                  <div className="flex flex-col">
                    <Image
                      src={
                        getExtension(
                          employeeDetails?.member?.profile?.nid_image_front
                        ) === "pdf"
                          ? PDF
                          : employeeDetails?.member?.profile?.nid_image_front
                      }
                      width={40}
                      height={30}
                      className={
                        getExtension(
                          employeeDetails?.member?.profile?.nid_image_front
                        ) === "pdf"
                          ? "object-contain"
                          : "object-cover"
                      }
                    />
                    <span className="text-accent flex items-center gap-1 text-xs mt-1">
                      <a
                        href={employeeDetails?.member?.profile?.nid_image_front}
                        target="_blank"
                        className="-mt-[2px] cursor-pointer"
                        rel="noreferrer"
                        download="NID Front Image"
                      >
                        <DownloadIcon width={10} height={10} />
                      </a>{" "}
                      Front
                    </span>
                  </div>
                )
              ) : null}
              {employeeDetails?.member?.profile?.nid_image_back ? (
                getExtension(
                  employeeDetails?.member?.profile?.nid_image_back
                ) === "pdf" ? null : (
                  <div className="flex flex-col">
                    <Image
                      src={
                        getExtension(
                          employeeDetails?.member?.profile?.nid_image_back
                        ) === "pdf"
                          ? PDF
                          : employeeDetails?.member?.profile?.nid_image_back
                      }
                      width={40}
                      height={30}
                      className={
                        getExtension(
                          employeeDetails?.member?.profile?.nid_image_back
                        ) === "pdf"
                          ? "object-contain"
                          : "object-cover"
                      }
                    />
                    <span className="text-accent flex items-center gap-1 text-xs mt-1">
                      <a
                        href={employeeDetails?.member?.profile?.nid_image_back}
                        target="_blank"
                        className="-mt-[2px] cursor-pointer"
                        rel="noreferrer"
                        download="NID Front Image"
                      >
                        <DownloadIcon width={10} height={10} />
                      </a>{" "}
                      Back
                    </span>
                  </div>
                )
              ) : null}
            </div>
          ) : null}
        </div>
      </InfoItem>
      <InfoItem title="Passport">
        <div className="flex items-center justify-between">
          {employeeDetails?.member?.profile?.passport_no || "N/A"}
          {employeeDetails?.member?.profile?.passport_image ? (
            <div>
              {
                <div className="flex flex-col">
                  <Image
                    src={
                      getExtension(
                        employeeDetails?.member?.profile?.passport_image
                      ) === "pdf"
                        ? PDF
                        : employeeDetails?.member?.profile?.passport_image
                    }
                    width={40}
                    height={30}
                    className="object-cover"
                  />
                  <span className="text-accent flex items-center justify-end gap-1 text-xs mt-1">
                    <a
                      href={employeeDetails?.member?.profile?.passport_image}
                      target="_blank"
                      className="-mt-[2px] cursor-pointer"
                      rel="noreferrer"
                      download="Passport Image"
                    >
                      <DownloadIcon width={10} height={10} />
                    </a>{" "}
                  </span>
                </div>
              }
            </div>
          ) : null}
        </div>
      </InfoItem>
      <InfoItem title="e-Signature">
        {employeeDetails?.member?.profile?.e_signature ? (
          <div>
            {
              <div className="flex flex-col">
                <Image
                  src={
                    getExtension(
                      employeeDetails?.member?.profile?.e_signature
                    ) === "pdf"
                      ? PDF
                      : employeeDetails?.member?.profile?.e_signature
                  }
                  width={40}
                  height={30}
                  className="object-cover"
                />
                <span className="text-accent flex items-center justify-end gap-1 text-xs mt-1">
                  <a
                    href={employeeDetails?.member?.profile?.e_signature}
                    target="_blank"
                    className="-mt-[2px] cursor-pointer"
                    rel="noreferrer"
                    download="e-Signature Image"
                  >
                    <DownloadIcon width={10} height={10} />
                  </a>{" "}
                </span>
              </div>
            }
          </div>
        ) : null}
      </InfoItem>
      <InfoItem title="Blood Group">
        {employeeDetails?.member?.profile?.blood_group || undefined}
      </InfoItem>
      <InfoItem title="Social Media">
        {Object?.values(employeeDetails?.member?.social_links || {})?.length ? (
          <Space align="center">
            <a
              href={employeeDetails?.member?.social_links?.facebook}
              target="_blank"
              rel="noreferrer"
              className="text-body-text hover:text-body"
            >
              {FaFacebook && typeof FaFacebook === "function" ? (
                <FacebookIcon />
              ) : null}
            </a>
            <a
              href={employeeDetails?.member?.social_links?.instagram}
              target="_blank"
              rel="noreferrer"
              className="text-body-text hover:text-body"
            >
              <InstagramIcon />
            </a>
            <a
              href={employeeDetails?.member?.social_links?.linkedIn}
              target="_blank"
              rel="noreferrer"
              className="text-body-text hover:text-body"
            >
              <LinkedinIcon />
            </a>
          </Space>
        ) : undefined}
      </InfoItem>
      {/* {data?.data?.employee?.status !== "invited" && (
        <EditButtonEmployee type="Personal" />
      )} */}
    </ul>
  );
}
